import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createSlots as _createSlots } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    disabled: _ctx.disabled,
    multiple: false,
    placeholder: _ctx.placeholder,
    value: _ctx.value,
    "allow-clear": "",
    "option-filter-prop": "title",
    "show-search": "",
    onChange: _ctx.onChange
  }, _createSlots({
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.records, (item) => {
        return (_openBlock(), _createBlock(_component_a_select_option, {
          key: _ctx.byName ? item.serviceClassificationName : item.id,
          title: item.serviceClassificationName,
          value: _ctx.byName ? item.serviceClassificationName : item.id
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.serviceClassificationName), 1)
          ]),
          _: 2
        }, 1032, ["title", "value"]))
      }), 128))
    ]),
    _: 2
  }, [
    (_ctx.showAdd)
      ? {
          name: "suffixIcon",
          fn: _withCtx(() => [
            _createVNode(_component_a_tooltip, { title: "去创建" }, {
              default: _withCtx(() => [
                _createVNode(_component_plus_outlined, { onClick: _ctx.goAdd }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ])
        }
      : undefined
  ]), 1032, ["disabled", "placeholder", "value", "onChange"]))
}